<template>
  <Layout>
    <PageHeader :title="$t('prontuariosPage.title')" :items="breadcrumbItems" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <MedicalRecordsPanel />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import MedicalRecordsPanel from "./MedicalRecordsPanel.vue";

export default {
  page: {
    title: "Prontuários",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, MedicalRecordsPanel },
  computed: {
    breadcrumbItems() {
      return [
        { text: this.$t("menuitems.dashboard.text"), href: "/" },
        { text: this.$t("menuitems.prontuarios.text"), active: true },
      ];
    },
  },
};
</script>
